import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { nanoid } from '@reduxjs/toolkit';
import { getLoginFormErrorLabel } from 'src/shared/helpers';
import { useIsLastTry } from 'src/shared/hooks/use-is-last-try';
import { addNotification, setAlertMessageModalReason } from 'src/shared/slices/app-slice';

import { Button } from '@alfalab/core-components/button/cssm';
import { Gap } from '@alfalab/core-components/gap';
import { Input } from '@alfalab/core-components/input';
import { Typography } from '@alfalab/core-components/typography';

export const LoginForm = () => {
    const dispatch = useDispatch();
    const { origin } = window.location;
    const isLastTry = useIsLastTry();

    const {
        register,
        formState: { isValid },
    } = useForm();

    const [searchParams, setSearchParams] = useSearchParams();
    const errorCode = searchParams.get('failure-reason');

    const port = window.location.port ? `:${window.location.port}` : '';

    const onChange = () => {
        if (searchParams.has('error')) {
            searchParams.delete('error');
            setSearchParams(searchParams);
        }
    };

    if (isLastTry) {
        window.location.replace(origin);
    }

    useEffect(() => {
        if (errorCode === 'password_changed') {
            dispatch(
                addNotification([
                    {
                        id: nanoid(),
                        title: 'Похоже, изменился пароль',
                        subTitle: 'Представьтесь ещё раз',
                        badge: 'attention',
                    },
                ]),
            );
        }
        if (errorCode === 'user_blocked') {
            dispatch(setAlertMessageModalReason('user_blocked'));
        }
    }, [errorCode, dispatch]);

    return (
        <div className='authForm'>
            <Typography.Title view='small' font='system' tag='div'>
                Представьтесь и входите скорее
            </Typography.Title>
            <Gap size='l' />
            <form className='apmui-form' id='auth_form' method='POST' action='/my.policy'>
                <Input
                    block={true}
                    label='Рабочая почта'
                    type='email'
                    size='m'
                    id='username'
                    autoCapitalize='off'
                    autoComplete='off'
                    error={getLoginFormErrorLabel(errorCode)}
                    autoFocus={true}
                    {...register('username', {
                        required: 'required',
                        pattern: /\S+@\S+\.\S+/,
                        onChange,
                    })}
                />
                <Gap size='2xl' />
                <Button view='primary' size='m' block={true} type='submit' disabled={!isValid}>
                    Продолжить
                </Button>
                <Gap size='m' />
                <Button
                    view='secondary'
                    size='m'
                    block={true}
                    type='submit'
                    href={`https://alfateam.alfabank.ru${port}`}
                >
                    Вход для гостей и кандидатов
                </Button>
            </form>
        </div>
    );
};
